<template>
  <v-container
    text-xs-center
    class="mt-2 pt-0 px-4"
  >
    <v-card
      v-if="!enterLoading"
      flat
      class="mx-2 animated fadeIn delay-1s"
    >
      <v-layout
        row
        wrap
        class="mt-3 mb-2"
      >
        <!-- <v-flex xs12 v-if="getCustomer.id === '5f3960ccdb0e3500032c99ad' && eventCatalogue">
            <v-toolbar-items class="toolbarItems">
              <v-btn class="mb-4 elevation-1" block outline color='#099AB1' @click="copyLinkToClipboard(eventCatalogue.id)" height="40px">
                <v-icon class="pr-1">content_copy</v-icon>
                <h4 class="ma-2 pl-2">Link catálogo de Páscoa</h4>
              </v-btn>
            </v-toolbar-items>
          </v-flex> -->

        <v-flex
          xs12
          class="catalogue-select text-xs-left"
        >
          Escolha um catálogo para visualizar o conteúdo:
        </v-flex>
        <v-flex align-self-left>
          <v-autocomplete
            v-model="selectedTemplateCatalogue"
            :items="catalogueSelectItems"
            :loading="catalogueLoading"
            append-icon="$vuetify.icons.arrowDownIcon"
            item-text="name"
            return-object
            class="catalogue-select__select"
            color="#140C22"
            no-data-text="Nenhum catálogo encontrado..."
            @change="resetAndGetProducts"
          />
        </v-flex>
        <v-flex
          xs3
          style="text-align: end;"
          align-self-center
        >
          <v-btn
            id="copyLink"
            depressed
            :loading="copyLoading"
            class="catalogue-select__copy-link secondary-btn ma-0 px-0"
            color="#FFADDE"
            @click="copyCatalogueLink"
          >
            <v-icon
              class="mr-1"
              small
              color="primary"
            >
              mdi-content-copy
            </v-icon>
            <span style="text-transform: none">
              Link
            </span>
          </v-btn>
        </v-flex>
      </v-layout>

      <v-divider style="border: 1px solid #DDDDDD" />

      <v-layout
        row
        wrap
        class="mt-4"
        align-center
      >
        <v-flex xs1>
          <div class="catalogue-icon">
            <v-icon
              dark
              large
              style="heigth: 34px;"
            >
              {{ catalogueIcon }}
            </v-icon>
          </div>
        </v-flex>
        <v-flex
          xs6
          class="catalogue-select__catalogue-name px-3"
        >
          {{ selectedTemplateCatalogue.name }}
        </v-flex>
        <v-flex
          v-if="canPersonalize"
          xs5
          style="text-align: end;"
        >
          <v-btn
            id="personalize"
            depressed
            class="catalogue-select__personalize secondary-btn"
            color="#140C22"
            @click="goToPersonalize"
          >
            <v-icon
              class="mr-1"
              small
              color="white"
            >
              mdi-pencil
            </v-icon>
            <span style="text-transform: capitalize">
              Personalizar
            </span>
          </v-btn>
          <v-btn
            v-if="selectedTemplateCatalogue.catalogueId"
            id="unfavorite"
            depressed
            outline
            :loading="unfavoriteLoading"
            class="catalogue-select__personalize secondary-btn mt-0"
            color="#140C22"
            @click="unfavoriteDialog = true"
          >
            <v-icon
              class="mr-1"
              small
              color="#140C22"
            >
              mdi-heart-broken
            </v-icon>
            <span style="text-transform: capitalize">
              Desfavoritar
            </span>
          </v-btn>
        </v-flex>
        <v-flex xs12>
          <v-combobox
            ref="combobox"
            v-model="catalogueFilters"
            prepend-icon="$vuetify.icons.searchIcon"
            :items="allFilters"
            :menu-props="{
              closeOnContentClick: true
            }"
            dense
            small-chips
            clearable
            deletable-chips
            hide-selected
            label="Buscar"
            multiple
            no-data-text="Nenhum resultado encontrado..."
            @change="reset"
          />
        </v-flex>

        <v-layout
          row
          wrap
          class="order-by__txt"
          align-center
        >
          <v-flex
            xs4
          >
            <v-select
              ref="sectorSelect"
              v-model="catalogueSectorFilters"
              :items="allSectors"
              class="sector-filter"
              filled
              :menu-props="{ bottom: true, offsetY: true, closeOnContentClick: true}"
              dense
              @click.native.prevent.stop.capture="$event.stopPropagation()"
              @mouseup="handleClick('sectorSelect')"
            >
              <template #selection="{ item }">
                <span class="sector-filter__select">
                  {{ item }}
                </span>
              </template>
              <template #item="{ item }">
                <v-list-tile-content class="sector-filter__tile">
                  {{ item }}
                </v-list-tile-content>
              </template>
              <template #label>
                <span
                  class="sector-filter__slot"
                >
                  Setores
                </span>
              </template>
            </v-select>
          </v-flex>
          <v-flex
            xs5
            style="text-align: end;"
          >
            <span class="order-by__arrows mr-1">
              ↑↓
            </span>
            <span class="mr-3">
              Ordenar por:
            </span>
          </v-flex>
          <v-flex xs3>
            <v-select
              ref="sortSelect"
              v-model="catalogueSortAsc"
              :items="sort"
              item-text="label"
              append-icon=""
              filled
              :menu-props="{ bottom: true, offsetY: true }"
              dense
              @click.native.prevent.stop.capture="$event.stopPropagation()"
              @mouseup="handleClick('sortSelect')"
            >
              <template #selection="{ item }">
                <span class="order-by__select">
                  {{ item.label }}
                </span>
              </template>
              <template #item="{ item }">
                <v-list-tile-content class="order-by__select">
                  {{ item.label }}
                </v-list-tile-content>
              </template>
            </v-select>
          </v-flex>
        </v-layout>
      </v-layout>

      <v-layout
        row
        wrap
        justify-space-around
        class="mb-5 pb-2"
      >
        <v-flex
          v-for="product in filteredProducts"
          :key="product.sku"
          xs6
          md3
        >
          <ProductCard
            :product="product"
          />
        </v-flex>
      </v-layout>
      <div style="margin-bottom: 150px">
        <infinite-loading
          ref="infiniteLoading"
          spinner="spiral"
          @infinite="infiniteHandler"
        >
          <div slot="no-results">
            Sem mais resultados
          </div>
          <div slot="no-more">
            Sem mais resultados
          </div>
        </infinite-loading>
      </div>
    </v-card>
    <v-dialog
      v-model="unfavoriteDialog"
      max-width="317"
    >
      <ActionsDialog
        :dialog-text="`${sellerFirstName}, você tem certeza que deseja remover o catálogo “${selectedTemplateCatalogue.name}” dos favoritos?`"
        first-text="Sim, desfavoritar catálogo"
        second-text="Quero manter nos favoritos"
        :first-action="unfavoriteCatalogue"
        :second-action="() => { unfavoriteDialog = false }"
        :close="() => { unfavoriteDialog = false }"
      />
    </v-dialog>
    <v-progress-circular
      v-if="enterLoading"
      class="progress-circular"
      size="50"
      width="4"
      color="#140C22"
      indeterminate
    />
  </v-container>
</template>

<script>
import { everything } from '@sejazipper/layer-api-client';
import Promise from 'bluebird';
import { mapGetters } from 'vuex';
import Fuse from 'fuse.js';
import ProductCard from '@/components/ProductCard';
import ActionsDialog from '@/components/ActionsDialog';
import { APIService } from '@/resources/campanha.js';
import { EventBus } from '@/event-bus.js';
import { useZipperApi } from '../composables/useZipperApi';

const shortid = require('shortid');
const _ = require('lodash');

const api = new APIService();
const { client } = useZipperApi();

export default {
  components: {
    ProductCard,
    ActionsDialog,
  },
  data: () => ({
    page: 0,
    size: 25,
    enterLoading: true,
    awaitingSearch: false,
    allFilters: [],
    allSectors: [],
    products: [],
    filters: null,
    search: null,
    catalogueSectorFilters: 'Todos os produtos',
    totalProducts: null,
    selectingAllProducts: false,
    addingProducts: false,
    eventCatalogue: null,
    catalogueLink: null,
    sort: [
      {
        label: 'Maior Preço',
        value: false,
      },
      {
        label: 'Menor Preço',
        value: true,
      },
    ],
    searchHeaders: {
      categories: { header: 'Categoria:' },
      sizes: { header: 'Tamanho:' },
      colors: { header: 'Cor:' },
      sectors: { header: 'Setor:' },
    },
    templateCatalogues: [],
    favoriteCatalogues: [],
    catalogueSelectItems: [],
    selectedTemplateCatalogue: {},
    copyLoading: false,
    loadedProducts: false,
    unfavoriteLoading: false,
    catalogueLoading: false,
    unfavoriteDialog: false,
    searchProducts: [],
  }),
  computed: {
    catalogueSortAsc: {
      get() {
        return this.$store.state.catalogueSortAsc;
      },
      set(value) {
        this.$store.commit('SET_CATALOGUE_SORT_ASC', value);
      },
    },
    finalProducts() {
      let { products } = this;

      if (this.catalogueFilters.length) {
        if (!this.searchProducts.length) this.handleSearch();
        products = this.searchProducts;
      }

      if (products.length) {
        this.resetInfiniteLoading();
      }

      return products;
    },
    slicedProducts() {
      const sortDirection = this.catalogueSortAsc ? 'asc' : 'desc';
      let [withImage, withoutImage] = _.partition(this.finalProducts, 'mainImage');

      withImage = _.orderBy(withImage, ['preco'], [sortDirection]);
      withoutImage = _.orderBy(withoutImage, ['preco'], [sortDirection]);

      const sortedProducts = withImage.concat(withoutImage);

      return sortedProducts.slice(0, this.size * (this.page + 1));
    },
    filteredProducts() {
      const productsInStock = this.slicedProducts.filter((p) => (Math.max(...p.skus.map((sku) => sku.price)) || p.preco) > 0);

      if (this.selectedTemplateCatalogue.catalogueId) {
        return this.filterProductsByidERP(productsInStock);
      }

      return this.filterProductsSkusByTemplateCatalogue(productsInStock);
    },

    ...mapGetters(['getStore', 'getCustomer', 'getCatalogueSortAsc', 'getCatalogue', 'getCatalogueSectorFilters', 'getProfile']),

    catalogueFilters: {
      get() {
        return this.$store.state.catalogueFilters;
      },
      async set(value) {
        this.$store.commit('SET_CATALOGUE_FILTERS', value);
      },
    },
    catalogueId() {
      if (this.selectedTemplateCatalogue.catalogueId) {
        return this.selectedTemplateCatalogue.catalogueId;
      }
      return this.selectedTemplateCatalogue._id;
    },
    canPersonalize() {
      return (this.selectedTemplateCatalogue.defaultTemplateCatalogue && !this.getStore.defaultTemplateCatalogueId)
        || this.selectedTemplateCatalogue._id === this.getStore.defaultTemplateCatalogueId
        || this.selectedTemplateCatalogue.catalogueId;
    },
    catalogueIcon() {
      return this.selectedTemplateCatalogue.catalogueId
        ? '$vuetify.icons.heartOutlineIcon'
        : '$vuetify.icons.storeIcon';
    },
    sellerFirstName() {
      const names = this.getProfile.name.trim().split(' ');

      return names[0];
    },
    sizesUpperCase() {
      return this.filters.sizes.map((size) => size.toUpperCase());
    },
  },
  watch: {
    async catalogueFilters() {
      if (this.awaitingSearch) return;
      await this.handleSearch();
    },
    async getStore(store, oldVal) {
      if (store) {
        this.page = 0;
        this.products = [];
        console.log('Get corridors from getStore')
        if (this.loadedProducts) await this.getAllCorridorProducts();
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.enterLoading = false;
    }, 500);

    window.addEventListener('click', this.handleSectorClickOutside);
    window.addEventListener('click', this.handleSortClickOutside);
  },

  destroyed() {
    window.removeEventListener('click', this.handleSectorClickOutside);
    window.removeEventListener('click', this.handleSortClickOutside);
  },

  methods: {
    handleClick(ref) {
      this.$refs[ref].isMenuActive = !this.$refs[ref].isMenuActive;
    },
    handleSectorClickOutside() {
      this.$refs.sectorSelect.isMenuActive = false;
    },
    handleSortClickOutside() {
      this.$refs.sortSelect.isMenuActive = false;
    },
    reset() {
      this.$refs.combobox.lazySearch = '';
      this.$refs.combobox.isMenuActive = false;
    },
    async infiniteHandler($state) {
      if (this.awaitingSearch) return;
      if (!this.selectedTemplateCatalogue._id) await this.getCatalogueSelectItems();
      if (!this.products.length && !this.loadedProducts) {
        console.log('Get corridors from infiniteHandler')
        await this.getAllCorridorProducts();
        this.getFilters();
        this.allSectors = ['Todos os produtos', ...this.filters.sectors];
        $state.loaded();
        return;
      }

      if (this.slicedProducts.length < this.finalProducts.length) {
        this.page += 1;
        $state.loaded();
      } else {
        $state.complete();
      }
    },
    getFilters() {
      const skus = _.flatten(this.products.map((product) => product.skus));
      const filters = {
        categories: _.uniq(this.products.map((p) => p.categoria)).filter((p) => p),
        sizes: _.uniq(skus.map((s) => s.size)).filter((p) => p),
        colors: _.uniq(skus.map((s) => s.color)).filter((p) => p),
        sectors: _.uniq(this.products.map((p) => p.setor)).filter((p) => p),
      };
      Object.entries(filters).forEach((filter) => {
        if (filter[1].length) {
          this.allFilters = this.allFilters
            .concat(this.searchHeaders[filter[0]])
            .concat(filter[1]);
        }
      });
      this.filters = filters;
    },
    async getCorridorProducts(corridor) {
      if (!this.getCustomer) return;
      try {
        const products = await client.chain.query.findProductsByStoreAndCorridor({
          customerId: this.getCustomer.id, storeId: this.getStore.id, corridor,
        }).get({
          id: true,
          descricaoCurta: true,
          categoria: true,
          setor: true,
          cor: true,
          idERP: true,
          reference: true,
          preco: true,
          mainImage: true,
          imagens: true,
          skus: {
            color: true,
            idLoja: true,
            price: true,
            size: true,
            oldPrice: true,
            currentStock: true,
          },
        });
        if (!products.length) return;
        products.forEach((product) => {
          const sizes = product.skus.map((sku) => sku.size);
          product.sizes = sizes.join(' ').toUpperCase();
          product.searchString = this.getSearchString(product);
        });
        this.products = this.products.concat(products);
        this.products = _.uniqBy(this.products, 'id');
        this.$store.dispatch('setProducts', this.products);
      } catch (e) {
        console.log(e);
      }
    },
    async getAllCorridorProducts() {
      this.loadedProducts = false;

      if (!this.getCustomer) return false;
      let { corridors } = this.selectedTemplateCatalogue;

      if (!corridors) {
        const templateByCatalogue = this.templateCatalogues.find((template) => (
          template._id === this.selectedTemplateCatalogue._id
        ));

        if (templateByCatalogue && templateByCatalogue.corridors) corridors = templateByCatalogue.corridors
        else corridors = [];
      }

      await Promise.map(corridors, async (corridor) => {
        await this.getCorridorProducts(corridor);
      });

      this.loadedProducts = true;
      return true;
    },
    copyLinkToClipboard(id) {
      const catalogueLink = `https://shopper.kopenhagen.com.br/${id}`;
      const elem = document.createElement('textarea');
      elem.value = catalogueLink;
      document.body.appendChild(elem);
      elem.select();
      document.execCommand('copy');
      document.body.removeChild(elem);

      this.emitSnackbar('#099AB1', 'Link copiado com sucesso');
    },
    emitSnackbar(text) {
      const snackBar = {};
      snackBar.value = true;
      snackBar.text = text;
      snackBar.color = '#140C22';
      snackBar.button = false;
      snackBar.icon = '$vuetify.icons.checkIcon';
      snackBar.class = {
        height: '120px',
        'font-size': '16px',
        'font-weight': '600',
        'justify-content': 'center',
      };
      EventBus.$emit('activeSnackBar', snackBar);
    },
    resetInfiniteLoading() {
      this.$refs.infiniteLoading.stateChanger.reset();
    },
    completeInfiniteLoading() {
      this.$refs.infiniteLoading.stateChanger.loaded();
    },
    async resetAndGetProducts() {
      this.$store.dispatch('setCatalogueId', this.catalogueId);
      this.getCatalogueLink();
      this.awaitingSearch = true;
      this.page = 0;
      this.products = [];
      this.resetInfiniteLoading();
      await this.getAllCorridorProducts();
      this.awaitingSearch = false;
      this.completeInfiniteLoading();
    },
    async getFavoriteCatalogues() {
      const res = await client.chain.query
        .findAllFavoriteCataloguesBySellerIdAndStoreId({
          customerId: this.getCustomer.id,
          sellerId: this.$auth.user.sub,
          storeId: this.getStore.id,
        })
        .get({ ...everything });
      this.favoriteCatalogues = res.map((catalogue) => ({
        _id: catalogue.templateCatalogueId,
        name: catalogue.favoriteName,
        catalogueId: catalogue._id,
        productIds: catalogue.productIds,
      }));
      this.$store.dispatch(
        'setMaxFavoriteCatalogues',
        this.favoriteCatalogues.length === 5,
      );
    },
    async getTemplateCatalogues() {
      const res = await client.chain.query
        .findAllTemplateCatalogue({ customerId: this.getCustomer.id })
        .get({
          ...everything,
          corridors: {
            ...everything,
            priceRange: { ...everything, __typename: false },
            saleRange: { ...everything, __typename: false },
            __typename: false,
          },
        });
      this.templateCatalogues = res.filter((template) => !template.disabled);
    },
    async getCatalogueSelectItems() {
      this.catalogueLoading = true;
      this.catalogueSelectItems = [];

      await Promise.all([
        this.getFavoriteCatalogues(),
        this.getTemplateCatalogues(),
      ]);

      if (this.favoriteCatalogues.length) {
        this.catalogueSelectItems = this.catalogueSelectItems.concat(
          [{ header: `Catálogos Favoritos (${this.favoriteCatalogues.length}/5):` }],
          this.favoriteCatalogues,
        );
      }
      this.catalogueSelectItems = this.catalogueSelectItems.concat(
        [{ header: 'Catálogos:' }],
        this.templateCatalogues,
      );
      this.selectedTemplateCatalogue = this.getDefaultTemplateCatalogue();
      this.getCatalogueLink();

      this.catalogueLoading = false;
    },
    getDefaultTemplateCatalogue() {
      let templateCatalogue = this.templateCatalogues.find((template) => (
        (template._id === this.getStore.defaultTemplateCatalogueId)
      ));
      if (!templateCatalogue) {
        templateCatalogue = this.templateCatalogues.find((template) => template.defaultTemplateCatalogue) || {};
      }
      this.$store.dispatch('setCatalogueId', templateCatalogue._id);
      return templateCatalogue;
    },
    discountFilter(product, corridor) {
      if (
        !corridor.saleRange
        || (!corridor.saleRange.start && !corridor.saleRange.end)
      ) return true;
      const { start, end } = corridor.saleRange;
      const discount = Math.abs((product.price / product.oldPrice) - 1) * 100 || 0.0;
      return discount >= start && discount <= end;
    },
    priceFilter(product, corridor) {
      if (
        !corridor.priceRange
        || (!corridor.priceRange.start && !corridor.priceRange.end)
      ) return true;
      const { start, end } = corridor.priceRange;
      return product.price >= start && product.price <= end;
    },
    sizesFilter(product, corridor) {
      if (
        !corridor.sizes
        || !corridor.sizes.length
      ) return true;
      return corridor.sizes.includes(product.size);
    },
    sectorFilter(product) {
      if (this.catalogueSectorFilters === 'Todos os produtos') return true;
      return product.setor === this.catalogueSectorFilters;
    },
    filterProductsSkusByTemplateCatalogue(products) {
      return products.filter((product) => (
        product.skus.some((sku) => (
          this.selectedTemplateCatalogue.corridors.some((corridor) => (
            this.priceFilter(sku, corridor)
              && this.discountFilter(sku, corridor)
              && this.sizesFilter(sku, corridor)
              && this.sectorFilter(product)
          ))
        ))
      ));
    },
    filterProductsByidERP(products) {
      return products.filter((product) => (
        this.selectedTemplateCatalogue.productIds.includes(product.idERP)
      ));
    },
    copyCatalogueLink() {
      window.Clipboard.copy(this.catalogueLink);
      this.emitSnackbar('Link copiado com sucesso');
    },
    generateCatalogueURL(catalogueId) {
      if (this.getCustomer.nickname) {
        return `https://${this.getCustomer.nickname.toLowerCase()}.whts.shop/${catalogueId}`;
      }
      return `https://shop.sejazipper.com/${catalogueId}`;
    },
    async createCatalogue() {
      const catalogo = {
        id: shortid.generate(),
        storeId: this.getStore.id,
        customerId: this.getCustomer.id,
        sellerId: this.$auth.user.sub,
        templateCatalogueId: this.selectedTemplateCatalogue._id,
      };
      const catalogue = await api.createCatalogue(catalogo);
      return this.generateCatalogueURL(catalogue.id);
    },
    async getCatalogueLink() {
      this.copyLoading = true;
      if (this.selectedTemplateCatalogue.catalogueId) {
        this.catalogueLink = this.generateCatalogueURL(this.selectedTemplateCatalogue.catalogueId);
      } else {
        this.catalogueLink = await client.chain.query
          .getCatalogueLinkByTemplateCatalogueIdAndSellerId({
            customerId: this.getCustomer.id,
            storeId: this.getStore.id,
            sellerId: this.$auth.user.sub,
            templateCatalogueId: this.selectedTemplateCatalogue._id,
          })
          .get(true);
      }
      if (!this.catalogueLink) this.catalogueLink = await this.createCatalogue();
      this.copyLoading = false;
    },
    async unfavoriteCatalogue() {
      this.unfavoriteDialog = false;
      this.unfavoriteLoading = true;
      await client.chain.mutation
        .unfavoriteCatalogueByIdAndSellerId({
          customerId: this.getCustomer.id,
          catalogueId: this.selectedTemplateCatalogue.catalogueId,
          sellerId: this.$auth.user.sub,
        })
        .get(true);
      await this.getCatalogueSelectItems();
      this.emitSnackbar('Catálogo removido dos favoritos com sucesso');
      this.unfavoriteLoading = false;
      await this.resetAndGetProducts();
    },
    goToPersonalize() {
      this.$store.dispatch('clearCheckout');
      this.$router.push('/personalizar');
    },
    getSearchString(product) {
      const keys = ['descricaoCurta', 'cor', 'setor', 'categoria', 'idERP', 'reference'];
      return keys.map((key) => this.normalize(product[key])).join(' ');
    },
    normalizeFilters(filters) {
      return filters.map((word) => this.normalize(word));
    },
    normalize(word) {
      if (word) return word.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      return '';
    },
    handleSearch() {
      if (!this.loadedProducts) return;

      let filters = this.normalizeFilters(this.catalogueFilters);
      filters = filters.map((filter) => filter.toUpperCase());
      const { products } = this;
      const sizes = this.sizesUpperCase;
      const sizeFilters = [];

      if (sizes) {
        filters.forEach((filter) => {
          if (sizes.includes(filter)) {
            sizeFilters.push(filter);
          }
        });
        filters = filters.filter((filter) => !sizeFilters.includes(filter));
      }
      filters = filters.join(' ');

      const fuseOptions = {
        keys: ['searchString', 'sizes'],
        threshold: 0.3,
        location: 0,
        distance: 400,
        includeMatches: true,
        useExtendedSearch: true,
        ignoreCase: true,
        shouldSort: true,
      };

      const query = {
        $and: [],
      };

      if (filters) {
        query.$and.push({
          $path: 'searchString',
          $val: filters,
        });
      }

      if (sizeFilters.length) {
        query.$and.push({
          $path: 'sizes',
          $val: sizeFilters.join(' '),
        });
      }

      const fuse = new Fuse(products, fuseOptions);

      const results = fuse.search(query).map((result) => result.item);

      this.searchProducts = results;
      this.page = 0;
    },
  },
};
</script>

<style scoped lang="scss">

.toolbar {
  position: sticky;
  top: 0;
  z-index: 2;
  padding-top: 60px;
}

.toolbarItems {
  width: 100%;
  height: 34px;
}

.order-by {
  font-family: 'Nunito sans';
  font-style: normal;
  &__txt {
    font-weight: 300;
    font-size: 10px !important;
  }
  &__arrows {
    font-weight: 1000;
    font-size: 16px;
  }
  &__select {
    font-family: 'Nunito sans';
    font-weight: 400;
    font-size: 10px;
    line-height: 28px;
  }
}

.sector-filter {
  font-family: 'Nunito sans';
  font-style: normal;
  line-height: 14px;
  &__txt {
    font-weight: 300;
    font-size: 10px !important;
  }
  &__select {
    font-family: 'Nunito sans';
    font-weight: 400;
    font-size: 9px;
    line-height: 10px
  }
  &__tile {
    font-family: 'Nunito sans';
    font-style: normal;
    font-size: 10px;
  }
  &__title {
    padding-left: 0px;
    line-height: 14px;
    font-size: 10px;
    font-weight: 400;
  }
  &__slot {
    font-family: 'Nunito sans';
    font-style: normal;
    font-size: 14px ;
    line-height: 0px;
    word-wrap: break-word;
  }
}

::v-deep .v-list__tile {
  border: 1px solid #F1F1F1;
  &__title {
    padding-left: 30px;
    font-size: 10px;
    font-family: 'Neue-Metana';
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
    text-transform: lowercase;
  }
  &__title::first-letter {
    text-transform: uppercase;
  }
}

.catalogue-select {
  font-family: 'Nunito Sans';
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0em;
  &__copy-link {
    width: 85px;
    height: 26.5px;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    border-radius: 105px;
  }
  &__personalize {
    width: 138px;
    height: 26.5px;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    border-radius: 105px;
    color: white;
    margin-right: 0;
  }
  &__select {
    width: 90%;
  }
  &__catalogue-name {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    text-align: start;
  }
}

.catalogue-icon {
  display: inline-block;
  background-color: #140C22;
  border-radius: 50%;
  width: 32px;
  height: 32px;
}

.progress-circular {
  height: 50vh !important;
}

::v-deep .v-subheader {
  font-family: 'Neue-Metana';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  color: #000;
  background-color: #F8F4F0;
  border-radius: 5px;
  height: 45.71px;
}

::v-deep .v-list {
  padding: 0;
}

::v-deep .v-select__slot {
  font-family: 'Neue-Metana';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 102%;
}

::v-deep .sector-filter .v-select__selections input {
  display: contents
}

</style>
